// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"237":"96154109","532":"d3b249c3"}[chunkId] + ".chunk.js");